import { formatDate } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { FilterDictionary } from 'src/app/shared/table-search/filter-dictionary';
import { StateService } from 'src/app/state.service';
import { environment } from 'src/environments/environment';

export interface ActionIcon {
  icon: string;
  title: string;
  routerLink: string;
  clickMethod: string;
  checkDisable?: boolean;
  disabled?: boolean;
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit, OnDestroy, AfterViewInit {

  selector: { selector: '[reload]' }
  totalElements: number = 0;
  headerStyle: string;
  displayedColumns: string[];
  exportPrefix = 'tgbat_';
  titleExcel: string;
  defaultPageIndex = 0;
  defaultPageSize = 10;
  defaultFilter = '';
  //to be set in extended class if not name
  primarySort: Sort = {active: 'name', direction: 'asc'};
  defaultSort: Sort = {active: 'name', direction: 'asc'};

  disableByProfile: boolean = false;
  profilesAllowEdit: string = '';
  listRoute: string;

  topMenuIcons: ActionIcon[] = [];
  actions: ActionIcon[] = [];
  placeholderSearch:string;
  placeholderSearchText: string;
  routePath: string;

  refreshClicked: boolean = false;

  public clickedRowId: string = '';

  dataSource = new MatTableDataSource<any>();
  //to use when all data is picked up in getItems (example tunnel-sections-list)
  fullDataSource = new MatTableDataSource<any>();
  //to use for next/previous to set id's in state
  listIds: number[] = [];

  //inject op deze manier als niet gebruikt in afgeleide classes
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private cookieService = inject(CookieService);
  private changeDetectorRefs = inject(ChangeDetectorRef);
  public stateService = inject(StateService);

  filterFields: string[] = [];
  filters: FilterDictionary[] = [];
  translations: string[] = [];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  @ViewChild(MatSort, { static: true })  set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  };

  @ViewChild('filter') filter: ElementRef;

  formatted: string;
  constructorName: string = this.constructor["name"];

  constructor(public translate: TranslateService, public sidenavService: SideNavService)
  {
    this.formatted = formatDate(new Date(), 'yyyy-MM-dd hh:mm', 'en');
  }

  ngOnDestroy(): void {

  }

    ngAfterViewInit(): void
    {
      setTimeout(() => {
        if (this.filter)
        {
          // server-side search
          fromEvent(this.filter.nativeElement,'keyup')
          .pipe(
              debounceTime(600),
              distinctUntilChanged(),
              tap(() => {
                this.defaultPageIndex = 0;
                this.paginator.pageIndex = 0;
                this.defaultFilter = this.filter.nativeElement.value;
                this.fullDataSource.data = undefined;
                this.setRouterParams();
                this.setRouterParamsCookies();
                this.getItems();
              })
          )
          .subscribe();
        }

        this.dataSource.sort.sortChange.subscribe(() => {
          this.paginator.pageIndex = 0;
          this.defaultSort = this.dataSource.sort;
          this.fullDataSource.data = undefined;

          this.setRouterParams();
          this.setRouterParamsCookies();
        }
          );

        merge(this.dataSource.sort.sortChange, this.paginator.page)
        .pipe(
          tap(() =>
          {
            //to prevent to may getItems when refresh
            if (!this.refreshClicked)
            {
              this.getItems();
            }
            this.refreshClicked = false;
          }
          ))
          .subscribe();

          if (this.filter) this.filter.nativeElement.value = this.defaultFilter;
          this.paginator.pageIndex = this.defaultPageIndex;
          this.paginator.pageSize = this.defaultPageSize;
          this.dataSource.sort.active = this.defaultSort.active;
          this.dataSource.sort.direction = this.defaultSort.direction;

          this.getItems();
    });
    }

    ngOnInit(): void {

      this.activatedRoute.url.subscribe((event) => {
        this.routePath = event[0].path;
        this.initAfterRoutePath();
      });

      this.defaultSort = this.primarySort;
      let foundParams = this.getRouterParams();
      if (!foundParams) this.getRouterParamsCookies();

      this.headerStyle = "background: " + environment.main_color + ";color:white;";
      this.translate
        .get([this.placeholderSearchText, 'icon_export_excel'])
        .subscribe((translations) => {
      this.placeholderSearch = translations[this.placeholderSearchText];
      this.titleExcel = translations['icon_export_excel'];
    });
    }

    initAfterRoutePath()
    {
      //do init stuff after routePath is known
    }

    getItems() {
      this.sidenavService.setLoading(true);

      //set visibility, validators
      if (this.stateService.getProfile())
      {
        this.setEnabled(this.stateService.getProfile().toString());
      }
      else
      {
        this.stateService.userProfile$.pipe(filter(val => val != null)).subscribe((userProfile) => {
          this.setEnabled(userProfile.toString());
        });
      }
    }

    setEnabled(userProfile: string)
    {
      if (userProfile && this.profilesAllowEdit.includes(userProfile))
      {
        this.disableByProfile = false;
      }
      else this.disableByProfile = true;

      this.topMenuIcons.forEach((a) =>
      {
        if (a.checkDisable)
        {
          a.disabled = this.disableByProfile;
        }
      });
    }

  refresh() {

    //to prevent getItems sort change
    this.refreshClicked = true;
    this.setRouterParams();
    this.setRouterParamsCookies();

    this.paginator.page.emit({
      length: this.paginator.getNumberOfPages(),
      pageIndex: this.defaultPageIndex,
      pageSize: this.defaultPageSize,
    });

    if (this.filter) this.filter.nativeElement.value = null;
    this.paginator.firstPage;
    if (this.filter) this.defaultFilter = this.filter.nativeElement.value;
    this.defaultPageIndex = 0;
    this.defaultSort = this.primarySort;
    this.defaultPageIndex = 0;
    this.fullDataSource.data = undefined;

    //removed because this will trigger extra getItems
    //this.filter.nativeElement.dispatchEvent(new Event("keyup"));
    this.getItems();
  }

  dummy(any: any) {
    //do nothing, only use the navigate
  }

  clickedRow(id: string)
  {
    this.clickedRowId === id ? this.clickedRowId = null : this.clickedRowId = id;
    this.changeDetectorRefs.detectChanges();
  }

  handlePageEvent(e: PageEvent)
  {
    this.defaultPageSize = e.pageSize;
    this.defaultPageIndex = e.pageIndex;
    this.setRouterParams();
    this.setRouterParamsCookies();
  }

  getRouterParams()
  {
    let found = false;

    if (this.activatedRoute.snapshot.queryParamMap.get('filter'))
      {
        found = true;
        this.defaultFilter = this.activatedRoute.snapshot.queryParams['filter'];
      }
    if (this.activatedRoute.snapshot.queryParamMap.get('page_index'))
    {
      found = true;
      this.defaultPageIndex = this.activatedRoute.snapshot.queryParams['page_index'];
    }
    if (this.activatedRoute.snapshot.queryParamMap.get('page_size'))
    {
      found = true;
      this.defaultPageSize = this.activatedRoute.snapshot.queryParams['page_size'];
    }
    if (this.activatedRoute.snapshot.queryParamMap.get('sort'))
    {
      if (this.activatedRoute.snapshot.queryParamMap.get('direction'))
      {
        found = true;
        let direction = this.activatedRoute.snapshot.queryParamMap.get('direction');
        let sortState: Sort = {active: this.activatedRoute.snapshot.queryParamMap.get('sort'), direction: direction === 'asc' ? 'asc' : 'desc'};
        this.defaultSort = sortState;
      }
      else this.defaultSort = this.primarySort;
    }
    else this.defaultSort = this.primarySort;

    return found;
  }

  getRouterParamsCookies()
  {
    if (this.cookieService.hasKey(this.constructorName + ".page_index"))
    {
      this.defaultPageIndex = Number(this.cookieService.get(this.constructorName + ".page_index"));
    }
    if (this.cookieService.hasKey(this.constructorName + ".page_size"))
    {
      this.defaultPageSize = Number(this.cookieService.get(this.constructorName + ".page_size"));
    }
    if (this.cookieService.hasKey(this.constructorName + ".page_filter"))
    {
      this.defaultFilter = this.cookieService.get(this.constructorName + ".page_filter");
    }
    if (this.cookieService.hasKey(this.constructorName + ".sort"))
    {
      if (this.cookieService.hasKey(this.constructorName + ".direction"))
      {
        let direction = this.cookieService.get(this.constructorName + ".direction");
        let sortState: Sort = {active: this.cookieService.get(this.constructorName + ".sort"), direction: direction === 'asc' ? 'asc' : 'desc'};
        this.defaultSort = sortState;
      }
    }
  }

  setRouterParams()
  {
    const sortingAndPaginationQueryParams = {
        page_size: this.defaultPageSize,
        page_index: this.defaultPageIndex,
        filter: this.defaultFilter,
        sort: this.defaultSort.active,
        direction: this.defaultSort.direction
      };

      this.router.navigate([], {
        queryParams: sortingAndPaginationQueryParams,
        queryParamsHandling: 'merge',
      });
  }

  setRouterParamsCookies()
  {
    this.cookieService.put(this.constructorName +  ".page_index", this.defaultPageIndex.toString());
    this.cookieService.put(this.constructorName + ".page_size", this.defaultPageSize.toString());
    this.cookieService.put(this.constructorName + ".page_filter", this.defaultFilter);
    this.cookieService.put(this.constructorName + ".sort", this.defaultSort.active.toString());
    this.cookieService.put(this.constructorName + ".direction", this.defaultSort.direction.toString());
  }

  filterchanged(filters: FilterDictionary[])
  {
    this.filters = filters;

    this.defaultPageIndex = 0;
    this.paginator.pageIndex = 0;
    this.defaultFilter = this.filter ? this.filter.nativeElement.value : "";
    this.fullDataSource.data = undefined;
    this.setRouterParams();
    this.setRouterParamsCookies();
    this.getItems();


  }
}


